import React from 'react'

import AppDirectoryPromo from '../../../../assets/images/promo-oauth2-app-directory.png'

import './OAuth2AppDirectoryUpsell.scss'

export const OAuth2AppDirectoryUpsellBody: React.FC = () => {
  return (
    <>
      <img src={AppDirectoryPromo} alt='App directory promo' className='zocks-border-0.5 app-directory-upsell-promo object-fit-contain' />
      <div className='d-flex flex-column gap-1'>
        <h5>
          Bring your <span className='zocks-text-primary'>client intelligence</span> into tools you and your team use
        </h5>
        <div className='paragraph-medium fw-bold'>
          Your AI Assistant detects important signals from meetings - such as life events and referrals - then triggers your Zapier workflows automatically.
        </div>
      </div>
    </>
  )
}

export const OAuth2AppDirectoryUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium fw-bold'>Spot opportunities: Life events and referrals are highlighted in every meeting note</div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium fw-bold'>Save hours on data entry: Signals flow to Zapier without manual updates</div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-success' />
        <div className='paragraph-medium fw-bold'>Never miss a follow-up: Workflows trigger the moment signals are detected</div>
      </div>
    </>
  )
}
